import React from "react";
import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import { TICKET_POST_FORM_SEND_PERMISSION } from "components/dashboard/AgentInbox/permissions";

const TTagElement = ({
    label,
    handleClick,
    otherClassNames,
    baseResources = TICKET_POST_FORM_SEND_PERMISSION,
}) => {
    return (
        <>
            {label && (
                <ComponentAccessControl baseResources={baseResources}>
                    <div
                        className={`tt_tag ${
                            otherClassNames ? otherClassNames : ""
                        }`}
                        onClick={handleClick}>
                        {label}
                    </div>
                </ComponentAccessControl>
            )}
        </>
    );
};

export default TTagElement;
